import { render, staticRenderFns } from "./Fees.vue?vue&type=template&id=e857c5ac&"
import script from "./Fees.vue?vue&type=script&lang=ts&"
export * from "./Fees.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports